import React, { useState } from "react";
import {
  Cpu,
  Monitor,
  Hash,
  AlertCircle,
  AlertTriangle,
  XCircle,
  Zap,
  RotateCcw,
  Layers,
  MapPin,
  Wifi,
  IndianRupee,
  Terminal,
  MonitorCogIcon,
  Construction,
} from "lucide-react";
import FirmwareUpdateDialog from "./ESP_Command/FirmwareUpdateHandler";
import DisplayUpdateDialog from "./ESP_Command/DisplayUpdateDialog";
import CmsEspOtaUpdateDialog from "./ESP_Command/CmsEspOtaUpdateDialog";
import FullResetDialog from "./ESP_Command/FullResetDialog";
import UploadFirmwareDialog from "./ESP_Command/UploadFirmwareDialog";
import SetCashbackOfferTitleDialog from "./ESP_Command/SetCashbackOfferTitleDialog";
import HeartbeatDashboard from "./StationDisplayData/HeartbeatDashboard";
import { useNavigate } from "react-router-dom";
import RunAdbCommandDialog from "./ESP_Command/RunAdbCommandDialog";
import MarkGunFaultyDialog from "./ESP_Command/MarkGunFaultyDialog";

// IMPORT YOUR REAL COMPONENTS

// ADMIN CARD UI
const AdminCardWidget = ({ icon: Icon, title, subtitle, onClick }) => {
  return (
    <div
      onClick={onClick}
      className="border border-gray-200 rounded-xl p-5 bg-white hover:shadow-md cursor-pointer transition group"
    >
      <div className="flex items-start gap-4">
        <div className="w-12 h-12 bg-gray-900 rounded-lg flex items-center justify-center">
          <Icon className="text-white" size={22} />
        </div>

        <div>
          <h3 className="text-md font-semibold text-gray-900 group-hover:text-black">
            {title}
          </h3>
          <p className="text-sm text-gray-600">{subtitle}</p>
        </div>
      </div>
    </div>
  );
};

const OTAMonitoringPage = () => {
  const [showDisplayDialog, setShowDisplayDialog] = useState(false);
  const [showFirmwareDialog, setShowFirmwareDialog] = useState(false);
  const [showESPDialog, setShowESPDialog] = useState(false);
  const [showFullResetDialog, setShowFullResetDialog] = useState(false);
  const [showUploadFirmwareDialog, setShowUploadFirmwareDialog] = useState(false);
  const [showSetCashbackDialog, setShowSetCashbackDialog] = useState(false);
  const [runAdbCommandDialog, setRunAdbCommandDialog] = useState(false);
  const [showMarkGunFaultyDialog, setShowMarkGunFaultyDialog] = useState(false);
  const navigate = useNavigate();

  const actions = [
    { icon: Cpu, title: "Firmware Update", subtitle: "System firmware upgrade" },
    { icon: Monitor, title: "Display App Update", subtitle: "Update display application" },
    { icon: RotateCcw, title: "Reset Station", subtitle: "System restart" },
    { icon: Wifi, title: "ESP Update", subtitle: "Update ESP" },
    { icon: Wifi, title: "Upload Firmware", subtitle: "Upload Firmware" },
    { icon: IndianRupee, title: "Set Cashback Offer Title", subtitle: "Set the active cashback offer title" },
    { icon: MonitorCogIcon, title: "Monitor Displays", subtitle: "Monitor display status" },
    { icon: Terminal, title: "Run ADB Command", subtitle: "Execute ADB commands on devices" },
    { icon: Construction, title: "Mark Gun Faulty", subtitle: "Make this Gun unavailable temorarly"}


  ];

  const openDialog = (title) => {
    if (title === "Display App Update") setShowDisplayDialog(true);
    else if (title === "Firmware Update") setShowFirmwareDialog(true);
    else if(title === "ESP Update") setShowESPDialog(true);
    else if(title === "Reset Station") setShowFullResetDialog(true);
    else if(title === "Upload Firmware") setShowUploadFirmwareDialog(true);
    else if(title === "Set Cashback Offer Title") setShowSetCashbackDialog(true);
    else if (title === "Monitor Displays") { navigate("/HeartbeatDashboard"); }
    else if (title === "Run ADB Command") setRunAdbCommandDialog(true);
    else if(title === "Mark Gun Faulty") setShowMarkGunFaultyDialog(true);
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <main className="max-w-7xl mx-auto py-12 px-6">
        <header className="mb-10 pb-6 border-b">
          <h1 className="text-2xl font-semibold tracking-tight text-ink">System Administration</h1>
          <p className="text-gray-600 mt-1">
            Manage OTA updates, firmware, and essential system configurations.
          </p>
        </header>

        {/* Action Cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {actions.map((action, index) => (
            <AdminCardWidget
              key={index}
              icon={action.icon}
              title={action.title}
              subtitle={action.subtitle}
              onClick={() => openDialog(action.title)}
            />
          ))}
        </div>
      </main>

      {/* DIALOGS */}
      {showDisplayDialog && (
        <DisplayUpdateDialog onClose={() => setShowDisplayDialog(false)} />
      )}

      {showFirmwareDialog && (
        <FirmwareUpdateDialog onClose={() => setShowFirmwareDialog(false)} />
      )}

      {
        showESPDialog && (
          <CmsEspOtaUpdateDialog onClose={() => setShowESPDialog(false)} />
        )
      }
      {
        showFullResetDialog && (
          <FullResetDialog onClose={() => setShowFullResetDialog(false)} />
        )
      }
      {
        showUploadFirmwareDialog && (
          <UploadFirmwareDialog onClose={() => setShowUploadFirmwareDialog(false)} />
        )
      }
      {
        showSetCashbackDialog && (
          <SetCashbackOfferTitleDialog onClose={() => setShowSetCashbackDialog(false)} />
        )
      }
      {
        runAdbCommandDialog && (
          <RunAdbCommandDialog onClose={() => setRunAdbCommandDialog(false)} />
        )
      }
      {
        showMarkGunFaultyDialog && (
          <MarkGunFaultyDialog onClose={() => setShowMarkGunFaultyDialog(false)} />
        )
      }


    </div>
  );
};

export default OTAMonitoringPage;
